import type { ReactNode} from 'react';
import { createContext, useContext, useMemo } from 'react';

type GridTableData = {
  [key: string]: any;
};

interface ContextValue<Data extends GridTableData = GridTableData, Meta = any> {
  rowIndex: number;
  row: Data;
  meta: Meta;
}

const Context = createContext<ContextValue | null>(null);

export const useGridTableRow = () => {
  const value = useContext(Context);

  if (!value) {
    throw new Error(`No value provided for context Grid Table Row`);
  }

  return value as ContextValue;
};

export interface GridTableRowProviderProps<Data extends GridTableData, Meta = undefined>
  extends ContextValue<Data, Meta> {
  children?: ReactNode;
}

export const GridTableRowProvider = <Data extends GridTableData, Meta = undefined>({
  row,
  rowIndex,
  children,
  meta,
}: GridTableRowProviderProps<Data, Meta>) => {
  const value = useMemo(
    () => ({
      row,
      rowIndex,
      meta,
    }),
    [row, meta, rowIndex],
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
